var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ai-eye-vision-processeor-technology-artificial_intelligence"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.3773,
    y1: 51.6818,
    x2: 55.4087,
    y2: 58.1307,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,41.6H53c-0.2,0.8-0.4,1.7-0.5,2.6h3.4V41.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.6305,
    y1: 51.445,
    x2: 55.6619,
    y2: 57.8939,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,48.4h2.9v-2.6h-3.4C52.6,46.7,52.8,47.6,53,48.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.1933,
    y1: 51.8539,
    x2: 55.2247,
    y2: 58.3028,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.9,39.8v-2.6c0-0.5,0.4-0.9,0.9-0.9h2.6v-2.3c-2.5,1.2-4.5,3.2-5.7,5.7H55.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.3847,
    y1: 51.6749,
    x2: 55.416,
    y2: 58.1239,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,55.1c-5.6-5.1-6-13.8-0.9-19.4c0.3-0.3,0.6-0.6,0.9-0.9c-5.5,2.4-10.6,5.8-14.8,10.1 C44.7,49.3,49.7,52.7,55.2,55.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1842,
    y1: 50.9271,
    x2: 56.2156,
    y2: 57.376,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.5,38.1H57.7v13.8h13.8V38.1z M58.5,39.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9 S58.5,40.3,58.5,39.8z M69.7,49.3c0,0.5-0.4,0.9-0.9,0.9h-8.6c-0.5,0-0.9-0.4-0.9-0.9v-6.1c0-0.2,0.1-0.5,0.3-0.6l2.6-2.6 c0.2-0.2,0.4-0.2,0.6-0.2h6c0.5,0,0.9,0.4,0.9,0.9V49.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.2482,
    y1: 50.8674,
    x2: 56.2795,
    y2: 57.3163,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.1,43.6v4.8H68v-6.9h-4.8L61.1,43.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6842,
    y1: 50.4596,
    x2: 56.7154,
    y2: 56.9085,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.1,56.6c0.8,0.2,1.7,0.4,2.6,0.5v-3.4h-2.6V56.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1496,
    y1: 50.9595,
    x2: 56.1809,
    y2: 57.4084,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.4,55.9v-2.3h-2.6c-0.5,0-0.9-0.4-0.9-0.9v-2.6h-2.3C54.9,52.7,56.9,54.7,59.4,55.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.2189,
    y1: 50.8947,
    x2: 56.2503,
    y2: 57.3436,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.2,37.2v2.6h2.3c-1.2-2.5-3.2-4.5-5.7-5.7v2.3h2.6C72.8,36.4,73.2,36.8,73.2,37.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1752,
    y1: 50.0003,
    x2: 57.2066,
    y2: 56.4492,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M75.4,50.2h-2.3v2.6c0,0.5-0.4,0.9-0.9,0.9h-2.6v2.3C72.2,54.7,74.3,52.7,75.4,50.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.957,
    y1: 50.2045,
    x2: 56.9883,
    y2: 56.6534,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M65.4,57c0.9-0.1,1.7-0.2,2.6-0.5v-2.9h-2.6V57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.9838,
    y1: 50.1793,
    x2: 57.0152,
    y2: 56.6282,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M73.9,55.1c5.5-2.4,10.6-5.8,14.8-10.1c-4.2-4.3-9.3-7.7-14.8-10.1c5.6,5.1,6,13.8,0.9,19.4 C74.5,54.6,74.2,54.9,73.9,55.1L73.9,55.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.6844,
    y1: 51.3946,
    x2: 55.7157,
    y2: 57.8435,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M65.4,36.4H68v-2.9c-0.8-0.2-1.7-0.4-2.6-0.5V36.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.9912,
    y1: 50.1724,
    x2: 57.0225,
    y2: 56.6213,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M73.2,48.4h2.9c0.2-0.8,0.4-1.7,0.5-2.6h-3.4V48.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.7381,
    y1: 50.4093,
    x2: 56.7693,
    y2: 56.8582,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.1,41.6h-2.9v2.6h3.4C76.5,43.3,76.4,42.4,76.1,41.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.4117,
    y1: 51.6499,
    x2: 55.443,
    y2: 58.0988,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M63.7,33c-0.9,0.1-1.7,0.2-2.6,0.5v2.9h2.6V33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1619,
    y1: 50.948,
    x2: 56.1933,
    y2: 57.3969,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.4,27.3l3.7-2.6c0.4,0.3,0.9,0.5,1.5,0.5c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6 c-1.4,0-2.6,1.2-2.6,2.6c0,0.2,0,0.5,0.1,0.7L77,26.2c-0.2,0.2-0.4,0.4-0.4,0.7v7.6l1.7,1V27.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.9667,
    y1: 52.0659,
    x2: 54.9981,
    y2: 58.5148,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M63.7,25v6.2c0.3,0,0.6,0,0.9,0s0.6,0,0.9,0V25c1.3-0.5,2.1-2,1.6-3.3c-0.5-1.3-2-2.1-3.3-1.6 c-1.3,0.5-2.1,2-1.6,3.3C62.4,24.2,63,24.8,63.7,25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.0492,
    y1: 52.9239,
    x2: 54.0806,
    y2: 59.3728,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M46.5,25.2c0.5,0,1-0.2,1.5-0.5l3.7,2.6V35c0.6-0.3,1.1-0.6,1.7-0.9v-7.1c0-0.3-0.1-0.5-0.4-0.7l-4.1-2.9 c0.1-0.2,0.1-0.5,0.1-0.7c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6C43.9,24,45,25.2,46.5,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.8357,
    y1: 49.3826,
    x2: 57.8671,
    y2: 55.8315,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M72.3,65v-7.6c-0.6,0.2-1.1,0.4-1.7,0.5v7c-1.3,0.5-2.1,2-1.6,3.3c0.5,1.3,2,2.1,3.3,1.6 c1.3-0.5,2.1-2,1.6-3.3C73.6,65.8,73.1,65.2,72.3,65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2869,
    y1: 48.9607,
    x2: 58.3182,
    y2: 55.4096,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M87,57.1c-1.1,0-2.1,0.7-2.4,1.7h-2.7v-6.6l-1.7,1.2v6.2c0,0.5,0.4,0.9,0.9,0.9h3.6c0.5,1.3,2,2.1,3.3,1.6 c1.3-0.5,2.1-2,1.6-3.3C89.1,57.8,88.1,57.1,87,57.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.079,
    y1: 50.0902,
    x2: 57.1104,
    y2: 56.5391,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M62,64.8h-2.7c-0.5-1.3-2-2.1-3.3-1.6c-1.3,0.5-2.1,2-1.6,3.3c0.5,1.3,2,2.1,3.3,1.6 c0.7-0.3,1.3-0.8,1.6-1.6h3.6c0.5,0,0.9-0.4,0.9-0.9v-6.9L62,58.6V64.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.841,
    y1: 51.2482,
    x2: 55.8724,
    y2: 57.6972,
    gradientTransform: "matrix(8 0 0 -8 -363.2599 480.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#A617FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#6359E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BCBFA"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M49.1,58.8h-2.7c-0.5-1.3-2-2.1-3.3-1.6c-1.3,0.5-2.1,2-1.6,3.3c0.5,1.3,2,2.1,3.3,1.6 c0.7-0.3,1.3-0.8,1.6-1.6h3.6c0.5,0,0.9-0.4,0.9-0.9v-5.1c-0.6-0.4-1.2-0.7-1.7-1.1V58.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerVision);
export default __webpack_public_path__ + "static/media/ComputerVision.613a2344b4d67dab1abfc60a79ac1b9b.svg";
export { ForwardRef as ReactComponent };